import React, { FC, useState } from "react";
import CarSimProps from "./Model/ICarSimOutputData";
import { UseTranslationContext } from './TranslationContext';
import parse, {
  DOMNode,
  Element,
  HTMLReactParserOptions,
} from 'html-react-parser';

import { useMediaQuery } from 'react-responsive';

import './css/normalize.css';
import './css/webflow.css';
import './css/webflow_carsim.css';
import './css/carsim.css';

interface CarSimTableProps {
  carSimTableData: CarSimProps;
  selectedYear: number;

}

export const CarSimResultComponent: FC<CarSimTableProps> = (props) => {

  const { currentLanguage, getKeyFromKeyId } = UseTranslationContext();
  const [selectMenuValue, setSelectMenuValue] = useState(0);

  const isAtBreakpoint = useMediaQuery({
    query: 'screen and (max-width: 991px)'
  });

  function GetToggleDisplay(myPanelId: number) {
    if (isAtBreakpoint) {
      if (myPanelId == selectMenuValue) {
        return ({ display: 'flex' } as React.CSSProperties);
      }
      else {
        return ({ display: 'none' } as React.CSSProperties);
      }
    }
    else {
      return ({ display: 'flex' } as React.CSSProperties);
    }
  }

  const handleMenuSelectChange = (event: any) => {
    setSelectMenuValue(event.target.value);
  };

  function getTableTitle() {
    return (
      <React.Fragment key='tableTitle'>
        {/*<div id="result_title_period" className="titre-table">{getKeyFromKeyId('RESULT_TITLE_PERIOD')}</div>*/}
        <div id="w-node-_94d353a6-0abc-e1ab-36f6-f8c6112aac14-7117b8a8" className="titre-table">{parse(getKeyFromKeyId('TAXABLE_BENEFIT_MULTILINE'))}</div>
        {/*<div id="result_title_benef" className="titre-table">{getKeyFromKeyId('TAXABLE_BENEFIT')}</div>*/}
        <div id="result_title_pro" className="titre-table">{getKeyFromKeyId('ESTIMATE_PROFESSIONAL_DEDUCTION')}</div>
        <div id="result_title_contri" className="titre-table">{parse(getKeyFromKeyId('CO2_CONTRIBUTION'))}</div>
      </React.Fragment>

    );
  }

  function getMonthlyLines() {

    let year = props.selectedYear;

    let arrayLines = [];

    for (var i = 0; i <= 12; i++) {
      if (i > 0) {
        let monthOfYear = new Date(year, i - 1, 1);
        const curMonthName = monthOfYear.toLocaleString(currentLanguage, { month: 'long' });

        let NbDaysInMonth = new Date(year, i, 0).getDate();
        let uniquekey = curMonthName + i;

        arrayLines.push(
          <React.Fragment key={curMonthName + i}>
            <div id={uniquekey} className="periode mois">{curMonthName}</div>
            <div id={uniquekey + 'col1'} className="numbers" style={GetToggleDisplay(0)}>{props.carSimTableData.listMonthlyBenefits[i - 1]}</div>
            <div id={uniquekey + 'col2'} className="numbers-col2" style={GetToggleDisplay(1)}>{props.carSimTableData.listMonthlyProfDeduction[i - 1]}</div>
            <div id={uniquekey + 'col3'} className="numbers-col3" style={GetToggleDisplay(2)}>{props.carSimTableData.listCo2Contribution[i - 1]}</div>
          </React.Fragment>
        );
      }
      else {
        arrayLines.push(
          <React.Fragment key='tableYearly'>
            <div id='result_year' className="periode">{getKeyFromKeyId("YEARLY").toUpperCase()}</div>
            <div id='result_year_col1' className="numbers" style={GetToggleDisplay(0)}>{props.carSimTableData.yearlyBenefits}</div>
            <div id='result_year_col2' className="numbers-col2" style={GetToggleDisplay(1)}>{props.carSimTableData.yearlyProfDeduction}</div>
            <div id='result_year_col3' className="numbers-col3" style={GetToggleDisplay(2)}>{props.carSimTableData.yearlyCo2Contribution}</div>
          </React.Fragment>
        );
      }
    }

    return (
      <>
        {arrayLines}
      </>
    );

  };

  return (

    <>
      <section id="result" className="w-node-_02995ff9-ad63-301e-95da-a5d23a0ae693-7117b8a8">
        <h3 id="title-h3-table" className="sous-titre-tableau w-node-_6b3af609-b6b5-45e2-f80e-bd567485f087-a2169bf1">{getKeyFromKeyId('RESULTS')} - {getKeyFromKeyId('RESULT_BENEF_TITLE')}</h3>
        <div id="w-node-_1d6c92de-3b23-ec44-d3f5-b5456157e92d-a2169bf1" className="form-block w-form">
          <form id="wf-form-Form" name="wf-form-Form" data-name="Form" method="get" className="select-form-mobile">
            <section className="section-form">
              <div className="text-field-icon">
                <select id="Co-t-ATN" name="Co-t-ATN" data-name="Coût ATN" className="select-field w-select" value={selectMenuValue} onChange={handleMenuSelectChange}>
                  <option key='benefitTitle' value={0}>{getKeyFromKeyId('TAXABLE_BENEFIT')}</option>
                  <option key='prof_est' value={1}>{getKeyFromKeyId('ESTIMATE_PROFESSIONAL_DEDUCTION')}</option>
                  <option key='co2_contrib' value={2}>{parse(getKeyFromKeyId('CO2_CONTRIBUTION'))}</option>
                </select>
              </div>
            </section>
          </form>
        </div>
        <div id="table" className="w-layout-grid tableau w-node-_04f81fd1-5088-e4f9-e32c-46159659ac5d-a2169bf1">
          {getTableTitle()}
          {getMonthlyLines()}
        </div>
        {props != null && props.selectedYear == 2023 && 
          <div>
            <p className="legende" style={{marginTop: '16px'}}>{getKeyFromKeyId('VEHICLE_ACQ_2023')}</p>
          </div>
        }
      </section>
    </>
  );

}
